import { CaseAttachmentEntity } from './case-attachment.entity';

/**
 * Work note domain entity.
 * Represents an internal work note on a case.
 * NOTE: ID fields use string type to support encrypted UUIDs
 */
export class WorkNoteEntity {
  public id!: string;
  public body!: string;
  public senderUserId!: string | null;
  public senderName!: string | null;
  public senderFirstName!: string | null;
  public senderLastName!: string | null;
  public noteType!: number;
  public createdOn!: string;
  public attachments!: CaseAttachmentEntity[];

  /**
   * Determines if this work note is system-generated.
   * System notes have null sender information.
   */
  public get isSystemGenerated(): boolean {
    return (
      this.senderUserId === null ||
      this.senderName === null ||
      this.senderFirstName === null ||
      this.senderLastName === null
    );
  }

  /**
   * Gets the display name for the sender.
   * Returns "System" for system-generated notes.
   */
  public get displaySenderName(): string {
    if (this.isSystemGenerated) {
      return 'System';
    }
    return this.senderName ?? 'Unknown';
  }

  /**
   * Gets the initials for avatar display.
   * Returns "SY" for system-generated notes.
   */
  public get senderInitials(): string {
    if (this.isSystemGenerated) {
      return 'SY';
    }

    const firstInitial = this.senderFirstName?.charAt(0) ?? '';
    const lastInitial = this.senderLastName?.charAt(0) ?? '';
    return `${firstInitial}${lastInitial}`.toUpperCase();
  }
}
